import preScreening from "@/services/preScreening";
import { getFilterQueryStringWithoutArray } from "@/helpers/helper";
import _ from "lodash";

const getDefaultState = () => {
    return {
        questionTypes: [],
        preScreeningQuestions: [],
        preScreeningResponses: [],
        isFetchingTransactions: false,
        preScreeningTransactions: [],
        questions: [],
        campaignCandidateResponses: {}
    }
}

const state = getDefaultState();

const getters = {
    questionTypes: state => state.questionTypes && state.questionTypes.filter(v => v.value !== "text_area").map(v => ({
        code: v?.lookup_value_id,
        label: _.startCase(v?.value),
    })) || [],
    preScreeningQuestions: state => state.preScreeningQuestions || [],
    preScreeningResponses: state => state.preScreeningResponses || [],
    isFetchingTransactions: state => state.isFetchingTransactions,
    preScreeningTransactions: state => state.preScreeningTransactions || [],
    getQuestions: state => state.questions || [],
    getCampaignCandidateResponses: state => state.campaignCandidateResponses || {},
}

const mutations = {
    ["SET_QUESTION_TYPES"](state, payload) {
        state.questionTypes = payload;
    },
    ["SET_PRE_SCRENNING_QUESTIONS"](state, payload) {
        state.preScreeningQuestions = payload;
    },
    ["RESET_PRE_SCREENING_QUESTIONS"](state) {
        state.preScreeningQuestions = [];
    },
    ["SET_PRE_SCREENING_RESPONSES"](state, payload) {
        state.preScreeningResponses = payload;
    },
    ["RESET_PRE_SCREENING_RESPONSES"](state) {
        state.preScreeningResponses = [];
    },
    ["SET_IS_FETCHING_TRANSACTIONS"](state, payload) {
        state.isFetchingTransactions = payload;
    },
    ["UPDATE_CANDIDATE_TRANSACTIONS"](state, payload) {
        if (payload && payload.length && state.preScreeningResponses.length) {
            const index = state.preScreeningResponses.findIndex(val => val.candidate_uid === payload[0].candidate_uid);
            if (index > -1) {
                let responses = state.preScreeningResponses;
                responses[index].transactions = payload;
                state.preScreeningResponses = [...responses]
            }
        }
    },
    ["SET_PRE_SCREENING_TRANSACTIONS"](state, payload) {
        state.preScreeningTransactions = payload;
    },
    ["RESET_PRE_SCREENING_TRANSACTIONS"](state) {
        state.preScreeningTransactions = [];
    },
    ["SET_QUESTIONS"](state, payload) {
        state.questions = payload;
    },
    ["SET_CANDIDATE_CAMPAIGN_TRANSACTIONS"](state, payload) {
        state.campaignCandidateResponses = payload;
    }
}

const actions = {
    initFetchingPreScreening: ({ commit, getters, dispatch }) => {
        const { questionTypes } = getters;
        let appendAction = [];
        commit("SET_FETCHING", true);
        if (!questionTypes.length)
            appendAction = [...appendAction, dispatch("fetchQuestionTypes")];
        return Promise.all(appendAction).then(res => {
            commit("SET_FETCHING", false);
            return res;
        });
    },
    fetchQuestionTypes({ commit, getters, dispatch }, all_rows = false) {
        // NOTE: 'pre_screening_question_type' now lives in the shared
        // lookup_categories/lookup_values tables. The old
        // `question_type_id__notin` query-param filter is no longer
        // supported by the shared endpoint (it is silently ignored server
        // side), so the email/mobile exclusion below is applied client
        // side instead, by value ("email"/"mobile") rather than by the
        // old, now-unstable numeric ids (previously 8 and 9).
        let queryPayload = { all_rows: true };
        const queryString = getFilterQueryStringWithoutArray(queryPayload)
        return preScreening
            .fetchQuestionTypes(queryString)
            .then(res => {
                let { data } = res;
                if (!all_rows) {
                    data = data.filter(v => !["email", "mobile"].includes(v?.value));
                }
                commit("SET_QUESTION_TYPES", data);
                return data;
            })
            .catch(err => {
                console.log("Error While Fetch Question Types", err);
                return err;
            });
    },
    createJobQuestion({ commit, getters, dispatch }, data) {
        const { getCustomerId: customer_uid } = getters;
        const { job_id, payload } = data;
        return preScreening
            .createJobQuestion({ customer_uid, payload, job_id })
            .then(res => {
                const { data } = res;
                return res;
            })
            .catch(err => {
                const message = "Error while create Job Question";
                console.log(message, err);
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                return err;
            })
    },
    updateJobQuestion({ commit, getters, dispatch }, data) {
        const { getCustomerId: customer_uid } = getters;
        const { job_id, payload } = data;
        return preScreening
            .updateJobQuestion({ customer_uid, payload, job_id })
            .then(res => {
                const { data } = res;
                return res;
            })
            .catch(err => {
                const message = "Error while update Job Question";
                console.log(message, err);
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                return err;
            })
    },
    deleteJobQuestion({ commit, getters, dispatch }, question_id) {
        const { getCustomerId: customer_uid } = getters;
        return preScreening
            .deleteJobQuestion({ customer_uid, question_id })
            .then(res => {
                const { data } = res;
                return res;
            })
            .catch(err => {
                const message = "Error while Delete Job Question";
                console.log(message, err);
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                return err;
            })
    },
    getPreScreeningQuestions({ commit, dispatch, getters }, job_id) {
        const { getCustomerId: customer_uid } = getters;
        const queryPayload = { job_id, all_rows: true };
        const query = getFilterQueryStringWithoutArray(queryPayload);
        return preScreening
            .getPreScreeningQuestions({ customer_uid, query })
            .then(res => {
                const { data } = res;
                commit("SET_PRE_SCRENNING_QUESTIONS", data);
                return res;
            })
            .catch(err => {
                const message = "Error while Get Job Questions";
                console.log(message, err);
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                return err;
            })
    },
    createCandidateTransaction({ commit, getters, dispatch }, data) {
        const { getCustomerId: customer_uid } = getters;
        const { job_id, payload, candidate_uid } = data;
        dispatch("showLoader");
        return preScreening
            .createCandidateTransaction({ customer_uid, payload, job_id, candidate_uid })
            .then(res => {
                const { data } = res;
                return res;
            })
            .catch(err => {
                const message = "Error while create Question Transaction";
                console.log(message, err);
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message,
                });
                return err;
            })
            .finally(() => {
                dispatch("hideLoader");
            })
    },
    deleteCandidateTransaction({ commit, dispatch, getters }, payload) {
        const { getCustomerId: customer_uid } = getters;
        const { job_id, candidate_uid } = payload
        return preScreening
            .deleteCandidateTransaction({ customer_uid, job_id, candidate_uid })
            .then(res => {
                const { data } = res;
                return res;
            })
            .catch(err => {
                const message = "Error while Delete Pre Screening Answers";
                console.log(message, err);
                dispatch("showToast", {
                    class: "dg-danger text-white",
                    message
                })
                return err;
            })
    },
    fetchJobPreScreeningResponses({ commit, dispatch, getters }, job_id) {
        commit("RESET_PRE_SCREENING_RESPONSES");
        commit("SET_FETCHING", true);
        const { getCustomerId: customer_uid } = getters;
        return preScreening
            .fetchJobPreScreeningResponses({ job_id, customer_uid })
            .then(res => {
                const { data } = res;
                commit("SET_PRE_SCREENING_RESPONSES", data);
                return res;
            })
            .catch(err => {
                const message = "Error While Fetch Pre Screening Responses";
                console.log(message, err);
                dispatch("showToast", {
                    class: "dg-danger text-white",
                    message
                })
                return err;
            }).finally(() => {
                commit("SET_FETCHING", false);
            })
    },
    fetchJobCandidateTransactions({ commit, dispatch, getters }, payload = {}) {
        commit("SET_IS_FETCHING_TRANSACTIONS", true);
        commit("RESET_PRE_SCREENING_TRANSACTIONS");
        const { job_id, candidate_uid } = payload;
        const { getCustomerId: customer_uid } = getters;
        let queryPayload = {}
        if (job_id)
            queryPayload = { ...queryPayload, job_id };
        if (candidate_uid)
            queryPayload = { ...queryPayload, candidate_uid };
        const queryString = getFilterQueryStringWithoutArray(queryPayload);
        return preScreening
            .fetchCandidateTransaction({ customer_uid, queryString })
            .then(res => {
                const { data } = res;
                commit("UPDATE_CANDIDATE_TRANSACTIONS", data);
                commit("SET_PRE_SCREENING_TRANSACTIONS", data);
                return res;
            })
            .catch(err => {
                const message = "Error While Fetch Candidate Response";
                console.log(message, err);
                dispatch("showToast", {
                    class: "dg-danger text-white",
                    message
                })
                return err;
            })
            .finally(() => {
                commit("SET_IS_FETCHING_TRANSACTIONS", false);
            })
    },
    async createQuestions({ commit, dispatch }, payload) {
        try {
            const res = await preScreening.createQuestions({ customer_uid: payload.customer_uid, payload});
            dispatch("showToast", {
                class: "bg-success text-white",
                message: "Pre-screening question(s) created successfully"
            })
            return res;
        } catch (err) {
            console.error("Error while creating questions", err);
            dispatch("showToast", {
                class: "bg-danger text-white",
                message: "Error while creating questions"
            })
            throw err;
        }
    },
    async fetchQuestions({ commit }, { customer_uid, query }) {
        try {
            const res = await preScreening.fetchQuestions({ customer_uid, query });
            commit("SET_QUESTIONS", res.data);
            return res;
        } catch (err) {
            console.error("Error while fetching questions", err);
            throw err;
        }
    },
    async updateQuestions({ commit, dispatch }, payload) {
        try {
            const res = await preScreening.updateQuestions({ customer_uid: payload.customer_uid, payload });
            dispatch("showToast", {
                class: "bg-success text-white",
                message: "Pre-screening question(s) updated successfully"
            })
            return res;
        } catch (err) {
            console.error("Error while updating questions", err);
            dispatch("showToast", {
                class: "bg-danger text-white",
                message: "Error while updating questions"
            })
            throw err;
        }
    },
    async createCampaignPreScreenTransaction({ dispatch }, data) {
        const { customer_uid, campaign_id, payload, candidate_uid } = data;
        dispatch("showLoader");
        return preScreening
            .createCampaignPreScreenTransaction({ customer_uid, campaign_id, candidate_uid, payload })
            .then(res => {
                const { data } = res;
                 dispatch("showToast", {
                    class: "bg-success text-white",
                    message: "Responses submitted successfully",
                });
                return data;
            })
            .catch(err => {
                const message = "Error while submitting responses";
                console.log(message, err);
                dispatch("showToast", {
                    class: "bg-danger text-white",
                    message: "Error while submitting responses",
                });
                return err;
            })
            .finally(() => {
                dispatch("hideLoader");
            })
    },
    async exportCampaignTransactions({ dispatch }, { customer_uid, campaign_id, campaign_name }) {
        try {
            const res = await preScreening.exportCampaignTransactions({
                customer_uid,
                campaign_id
            });

            const blob = new Blob([res.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = `${campaign_name}_responses.xlsx`;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            return true;
        } catch (err) {
            console.error("Error while exporting campaign transactions", err);
            dispatch("showToast", {
                class: "bg-danger text-white",
                message: "Error while exporting campaign transactions"
            });
            throw err;
        }
    },
    async fetchCampaignCandidateTransaction({ commit, getters }, { campaign_id, candidate_uid }) {
        try {
            const { getCustomerId: customer_uid } = getters;
            const queryString = `campaign_id=${campaign_id}&candidate_uid=${candidate_uid}`;
            const res = await preScreening.getCampaignCandidateTransaction({ customer_uid, queryString });
            commit("SET_CANDIDATE_CAMPAIGN_TRANSACTIONS", res.data);
            return res;
        } catch (err) {
            commit("SET_CANDIDATE_CAMPAIGN_TRANSACTIONS", []);
            console.error("Error while fetching campaign candidate transaction", err);
            throw err;
        }
    },
}

export default { state, getters, mutations, actions };